import apolloCache from "../../lib/graphql/apolloCache";
import { ICart } from "../../types/cart";
import { IGiftCard } from "../../types/giftCard";
import GetCart from "../repository/withCart/graphql/GetCart";

export const getCartFromCache = (): ICart | null | undefined => {
  const queryResponse = apolloCache.readQuery<{
    cart: ICart | undefined;
  }>({
    query: GetCart,
  });

  return queryResponse && queryResponse.cart;
};

export const cartTotal = ({ subTotal, coupon, giftCards }: ICart): number => {
  let total = subTotal;

  if (coupon && coupon.amount !== null) {
    total += coupon.amount < 0 ? coupon.amount : -coupon.amount;
  }

  if (giftCards) {
    total += giftCards.reduce(
      (acc: number, card: IGiftCard) =>
        (acc += card.amount < 0 ? card.amount : -card.amount),
      0
    );
  }

  if (total < 0) {
    total = 0;
  }

  return total;
};
